/**
 * PopTable
 *
 * View that controls the POP table interactions
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.Results.PopTable');

OT.Redesign.Views.Results.PopTable = Backbone.ViewManager.BaseView.extend({
    el: '#search_results_pop',

    template: 'Redesign/Results/_PopTable',

    events: {
        'click #whats_this': 'firePointsPopup',
        'click .pop-about-link-label': 'onClickPointsPopup',
        'mouseenter .ot-menu-hover-wrapper.pop-about-link': 'showPointsPopup',
        'mouseleave .ot-menu-hover-wrapper.pop-about-link': 'hidePointsPopup'
    },

    initialize: function() {
        var self = this;

        // Listen for result updates
        OT.Events.on('results:updated', function() { self.render(); });
    },

    beforeRender: function() {
        if (OT.Search.Helpers.isMapShowing()) {
            this.unsetView();
            return false;
        }

        this.templateData = OT.Search.Data.get();

        return true;
    },

    onRender: function() {
        this.$el.show();
    },

    /**
     * Launches the popup with information about rewards.
     */
    firePointsPopup: function(e) {
        OT.Common.openWindow(e.currentTarget.href, 480, 460, 'nav', 0, 1);
        return false;
    },

    togglePointsPopup: _.throttle(function(visible) {
        this.$el.find('.ot-menu').toggleClass('ot-menu-opened', visible);
    }, 400),

    onClickPointsPopup: function() {
        this.togglePointsPopup();
    },

    hidePointsPopup: function() {
        this.togglePointsPopup(false);
    },

    showPointsPopup: function() {
        this.togglePointsPopup(true);
    }
});
